import axios from 'axios';
import { API_BASE_URL } from '../lib/config';

// Use centralized config for API URL (ensures Railway is always used)
const baseURL = API_BASE_URL;

const api = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default api;
